<template >
    <div class="c-product-thumb-link">
        <div class="c-product-thumb">
            <!-- <div v-for="(label, index) in item.Labels" :key="`label-${index}`" class="c-product-label u-font-small" :class="'color-'+label">
                {{ label }}
            </div> -->
            <router-link :to="{ name: 'ProductDetailview', params: { id: product.ProductGroupId }}" class="c-product-thumb-image-link">
                <img v-if="product.Thumbnail" class="u-no-max-width" :src="product.Thumbnail.replace('[WIDTH]', 200).replace('[HEIGHT]', 160)" width="100" height="80" :alt="product.Name">
                <div v-else>
                    <img width="250px" src="@/assets/images/no_image_x300.png" alt="">
                </div>
            </router-link>

            <div class="c-product-thumb-info">
                <div>
                    <strong>{{product.Name}}</strong><br>
                    <!-- <span class="u-font-small u-opacity-50">Model {{ item.ErpId }}</span> -->
                </div>
            </div>
            <div class="c-wrapper-price c-retail-price u-font-small">
                <span>{{ $t('product.line.retail_price') }}</span>
                <span class="c-price">{{ product.UnitPrice | currency(customerCurrencySymbol) }}</span>
            </div>
            <!-- <div class="c-wrapper-price c-suggested-price u-font-small">
                <span>{{ $t('product.line.from_price') }}</span>
                <span class="c-price">{{ item.OriginalFromPrice | currency(customerCurrencySymbol) }}</span>
            </div> -->
        </div>
    </div>
</template>

<script>
    export default {
        props: ['product'],
        methods: { },
        computed: {
            customerCurrencySymbol() { 
                return this.$store.getters.userInfo.customerCurrencySymbol;
            }
        }
    }
</script>

<style lang="scss" scoped>

    @import "~@/assets/scss/private";

    $thumbwidth: em(100px);
    $overlayPadding: em($global-spacing-unit);

    .c-product-thumb {
        position: relative;
        z-index: 1;
        perspective: 250px;

        > * {
            position: relative;
            z-index: 2;
        }

        &:hover {
            z-index: 2;
            .c-product-thumb-overlay {
                visibility: visible;
                opacity: 1;
                transition: .2s;
                transform: none;
            }
        }
    }

    .c-product-thumb-link{
        text-decoration: none;
    }

    .c-product-thumb-image-link {
        display: block;
        position: relative;
        z-index: 2;
    }

    .c-product-thumb-overlay {
        content: '';
        position: absolute;
        width: calc(100% + #{$thumbwidth + $overlayPadding*3});
        height: calc(100% + #{$overlayPadding*2});
        left: -$overlayPadding;
        top: -$overlayPadding;
        box-shadow: 0 0 30px 0 rgba($color-base, .1);
        z-index: 1;
        background-color: white;
        padding: $overlayPadding;
        visibility: hidden;
        opacity: 0;
        transform-origin: top left;

        transform: rotateX(-3deg) rotateY(3deg);
    }

    .c-product-thumb-thumbs {
        margin-left: auto;
        width: $thumbwidth;
        height: 100%;
        overflow-y: auto;

        &__item {
            width: 100%;
            border: 1px solid transparent;
            height: 55px;

            img {
                height: 100%;
                object-fit: cover;
            }

            &:not(:last-child) {
                margin-bottom: em($global-spacing-unit-small);
            }

            &.is-active, &:focus, &:hover {
                background-color: transparent;
                box-shadow: none !important;
                border: 1px solid $color-neutral;
            }

        }
    }

    .c-product-thumb-image__slide {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        top: 0;
        img {
            width: 250px;
            height: 250px;
        }
    }

    .c-product-thumb-info {
        display: flex;
        justify-content: space-between;
        align-items: baseline;
        strong {
            display: inline-block;
            min-height: 25px;
        }
    }

    .c-price {
        color: white;
        padding: em($global-spacing-unit-tiny);
        font-weight: $medium;
        @include rfs($font-size-small);
    }
    .c-wrapper-price {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 5px;
    }

    .c-retail-price .c-price {
        color: $color-success;

        .label-promo & { color: $color-promo; }
        .label-new & { color: $color-new; }
        .label-bestseller & { color: $color-bestseller; }
        .label-advantage-pack & { color: $color-advantage-pack; }
        .label-popular & { color: $color-popular; }
        .label-super-deal & { color: $color-super-deal; }
        .label-daily-offer & { color: $color-daily-offer; }
        .label-web-only & { color: $color-web-only; }
        .label-outlet & { color: $color-outlet; }
        .label-limited-edition & { color: $color-limited-edition; }
        .label-seen-on-tv & { color: $color-seen-on-tv; }
        .label-campagne-model & { color: $color-campagne-model; }
        .label-last-pieces & { color: $color-last-pieces; }
        .label-marketing-model & { color: $color-marketing-model; }
        .label-vegan & { color: $color-vegan; }
    }
    .c-suggested-price .c-price {
        background-color: $color-success;

        .label-promo & { background-color: $color-promo; }
        .label-new & { background-color: $color-new; }
        .label-bestseller & { background-color: $color-bestseller; }
        .label-advantage-pack & { background-color: $color-advantage-pack; }
        .label-popular & { background-color: $color-popular; }
        .label-super-deal & { background-color: $color-super-deal; }
        .label-daily-offer & { background-color: $color-daily-offer; }
        .label-web-only & { background-color: $color-web-only; }
        .label-outlet & { background-color: $color-outlet; }
        .label-limited-edition & { background-color: $color-limited-edition; }
        .label-seen-on-tv & { background-color: $color-seen-on-tv; }
        .label-campagne-model & { background-color: $color-campagne-model; }
        .label-last-pieces & { background-color: $color-last-pieces; }
        .label-marketing-model & { background-color: $color-marketing-model; }
        .label-vegan & { background-color: $color-vegan; } 
    }

    .c-product-label {
        position: absolute;
        left: 0;
        top: 0;
        display: inline-block;
        padding: em($global-spacing-unit-tiny);
        color: $color-white;
        text-transform: capitalize;
        z-index: 10;

        &.color-promo { background-color: $color-promo; }
        &.color-new { background-color: $color-new; }
        &.color-bestseller { background-color: $color-bestseller; }
        &.color-advantage-pack { background-color: $color-advantage-pack; }
        &.color-popular { background-color: $color-popular; }
        &.color-super-deal { background-color: $color-super-deal; }
        &.color-daily-offer { background-color: $color-daily-offer; }
        &.color-web-only { background-color: $color-web-only; }
        &.color-outlet { background-color: $color-outlet; }
        &.color-limited-edition { background-color: $color-limited-edition; }
        &.color-seen-on-tv { background-color: $color-seen-on-tv; }
        &.color-campagne-model { background-color: $color-campagne-model; }
        &.color-last-pieces { background-color: $color-last-pieces; }
        &.color-marketing-model { background-color: $color-marketing-model; }
        &.color-vegan { background-color: $color-vegan; }
    }

</style>



// WEBPACK FOOTER //
// src/components/shop/UpsellingThumb.vue